module.exports = __webpack_public_path__ + "img/erweima1.jpg";